import React from 'react';
import { TrashBinIcon } from '../../../assets/icons/icons';
import { Checkbox } from '../../ui/Checkbox/Checkbox';
import { Tooltip } from '../../ui/Tooltip/Tooltip';
import { STATUS_META } from '../../../data/projectsTable';
import type { Project } from '../../../types/projectsTable';
import { cx } from '../../../utils/cx';
import { formatDate, formatMoney, formatNumber, formatProjectId, formatTime, shortName } from '../../../utils/format';
import styles from './ProjectsTable.module.scss';

interface ProjectRowProps {
    project: Project;
    selected: boolean;
    onToggle: (id: string) => void;
    onOpen: (project: Project) => void;
    onDelete: (project: Project) => void;
}

export function ProjectRow({ project, selected, onToggle, onOpen, onDelete }: ProjectRowProps) {
    const status = STATUS_META[project.status];
    const progress = project.total ? Math.round((project.done / project.total) * 100) : 0;

    return (
        <tr
            className={cx(styles[project.status], selected && styles.selected)}
            onClick={() => onOpen(project)}
        >
            <td onClick={(event) => event.stopPropagation()}>
                <Checkbox
                    checked={selected}
                    label={`Выбрать проект «${project.name}»`}
                    onChange={() => onToggle(project.id)}
                />
            </td>

            <td className={styles.name}>
                <b>{project.name}</b>
                <small>{formatProjectId(project.id)}</small>
            </td>

            <td className={styles.person}>
                {shortName(project.author)}
            </td>

            <td className={styles.date}>
                <b>{formatDate(project.date)}</b>
                <small>{formatTime(project.date)}</small>
            </td>

            <td className={styles.num}>
                {project.price ? (
                    <span className={styles.price}>
                        {formatMoney(project.price)}
                        <i>₽</i>
                    </span>
                ) : (
                    <span className={styles.dash}>—</span>
                )}
            </td>

            <td>
                <span className={cx(styles.status, styles[project.status])}>{status.label}</span>
            </td>

            <td className={styles.num}>
                {project.total ? (
                    <span className={styles.pos}>
                        <b>
                            {project.done} из {project.total}
                        </b>
                        {project.status === 'run' && (
                            <span className={styles.bar}>
                                <i style={{ width: `${progress}%` }} />
                            </span>
                        )}
                    </span>
                ) : (
                    <span className={styles.dash}>нет позиций</span>
                )}
            </td>

            <td onClick={(event) => event.stopPropagation()}>
                <div className={styles.rowActions}>
                    <Tooltip text="Удалить проект" align="right">
                        <button
                            type="button"
                            className={`${styles.iconBtn} ${styles.danger}`}
                            aria-label="Удалить проект"
                            onClick={() => onDelete(project)}
                        >
                            <TrashBinIcon className={styles.icon} />
                        </button>
                    </Tooltip>
                </div>
            </td>
        </tr>
    );
}
